import src from "IMAGE";
export default { src, width: 1234, height: 864, blurWidth: 0, blurHeight: 0};
